export enum HeartstylesQuadrants {
  staticValues = 0,
  humility = 1,
  love = 2,
  pride = 3,
  fear = 4
}
